import React from "react";
import { FieldExtensionComponentProps } from "@backstage/plugin-scaffolder-react";
import { useApi } from "@backstage/core-plugin-api";
import { identityApiRef } from "@backstage/core-plugin-api";
import { useAsync } from "react-use";
import { catalogApiRef } from "@backstage/plugin-catalog-react";
import { parseEntityRef } from "@backstage/catalog-model";

export const CurrentUserField = ({
  onChange,
}: FieldExtensionComponentProps<string>): JSX.Element => {
  const identityApi = useApi(identityApiRef);
  const catalogApi = useApi(catalogApiRef);

  useAsync(async () => {
    const profile = await identityApi.getProfileInfo();
    const userEmail = profile.email;

    const identity = await identityApi.getBackstageIdentity();
    const { name: userId } = parseEntityRef(identity.userEntityRef);

    const userRef = await catalogApi.getEntityByRef(`User:default/${userId}`);
    const githubHandle =
      userRef?.metadata?.annotations?.["github.com/user-login"];

    onChange(`@${githubHandle}` || userEmail);
  });

  return <></>;
};
